import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import { bsClass, prefix, splitBsProps } from '../bootstrap/utils/bootstrapUtils';
import { DEVICE_SIZES } from '../bootstrap/utils/StyleConfig';
class Col extends React.Component {
  render() {
    const {
      componentClass: Component,
      className,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = [];
    DEVICE_SIZES.forEach(size => {
      function popProp(propSuffix, modifier) {
        const propName = `${size}${propSuffix}`;
        const propValue = elementProps[propName];
        if (propValue != null) {
          classes.push(prefix(bsProps, `${size}${modifier}-${propValue}`));
        }
        delete elementProps[propName];
      }
      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');
      const hiddenPropName = `${size}Hidden`;
      if (elementProps[hiddenPropName]) {
        classes.push(`hidden-${size}`);
      }
      delete elementProps[hiddenPropName];
    });
    return /*#__PURE__*/React.createElement(Component, Object.assign({}, elementProps, {
      className: clsx(className, classes)
    }));
  }
}
Col.defaultProps = {
  componentClass: 'div'
};
export default bsClass('col', Col);